import {
  WebsiteThemeButtonsInterface,
  WebsiteThemeFormFieldsInterface,
  WebsiteThemeTextInterface,
} from 'src/shared/types/website-settings-types'
import { WebsiteStylesSettingsTypeEnum } from './types'

export const websiteStyleSettingsItemLocoKeys = {
  [WebsiteStylesSettingsTypeEnum.Typography]:
    'website_styles_settings.typography.title',
  [WebsiteStylesSettingsTypeEnum.ThemesAndColors]:
    'website_styles_settings.themes_and_colors.title',
  [WebsiteStylesSettingsTypeEnum.ButtonsAndLinks]:
    'website_styles_settings.buttons_and_links.title',
  [WebsiteStylesSettingsTypeEnum.FormFields]:
    'website_styles_settings.form_fields.title',
  [WebsiteStylesSettingsTypeEnum.Layout]:
    'website_styles_settings.layout.title',
}

export const primaryButtonColorsKeys: {
  key: keyof WebsiteThemeButtonsInterface
  title: string
}[] = [
  {
    key: 'primaryButtonTextColor',
    title: 'website_theme_settings.group.primary.button_text_color',
  },
  {
    key: 'primaryButtonBackgroundColor',
    title: 'website_theme_settings.group.primary.button_background_color',
  },
  {
    key: 'primaryHoveredButtonBackgroundColor',
    title:
      'website_theme_settings.group.primary.hovered_button_background_color',
  },
  {
    key: 'primaryPressedButtonBackgroundColor',
    title:
      'website_theme_settings.group.primary.pressed_button_background_color',
  },
  {
    key: 'primaryButtonBorderColor',
    title: 'website_theme_settings.group.primary.button_border_color',
  },
]

export const secondaryButtonColorsKeys: {
  key: keyof WebsiteThemeButtonsInterface
  title: string
}[] = [
  {
    key: 'secondaryButtonTextColor',
    title: 'website_theme_settings.group.secondary.button_text_color',
  },
  {
    key: 'secondaryButtonBackgroundColor',
    title: 'website_theme_settings.group.secondary.button_background_color',
  },
  {
    key: 'secondaryHoveredButtonBackgroundColor',
    title:
      'website_theme_settings.group.secondary.hovered_button_background_color',
  },
  {
    key: 'secondaryPressedButtonBackgroundColor',
    title:
      'website_theme_settings.group.secondary.pressed_button_background_color',
  },
  {
    key: 'secondaryButtonBorderColor',
    title: 'website_theme_settings.group.secondary.button_border_color',
  },
]

export const formFieldsColorKeys: {
  key: keyof WebsiteThemeFormFieldsInterface
  title: string
}[] = [
  {
    key: 'formFieldBackgroundColor',
    title: 'website_theme_settings.group.form_field.background_color',
  },
  {
    key: 'formFieldTextColor',
    title: 'website_theme_settings.group.form_field.text_color',
  },
  {
    key: 'formFieldBorderColor',
    title: 'website_theme_settings.group.form_field.border_color',
  },
]
export const typographyParagraphColorKeys: {
  key: keyof WebsiteThemeTextInterface
  title: string
}[] = [
  {
    key: 'paragraphTextColor',
    title: 'website_theme_settings.group.paragraph.text_color',
  },
  {
    key: 'paragraphBackgroundColor',
    title: 'website_theme_settings.group.paragraph.background_color',
  },
]

export const typographyHeadingColorKeys: {
  key: keyof WebsiteThemeTextInterface
  title: string
}[] = [
  {
    key: 'headingTextColor',
    title: 'website_theme_settings.group.heading.text_color',
  },
  {
    key: 'headingBackgroundColor',
    title: 'website_theme_settings.group.heading.background_color',
  },
]
